import { RmsAccountDetails } from '@/ui/features/accounts/RmsAccountDetails';
import { useAccountSlideoutAdditionalMenuItems } from '@/ui/features/accounts/hooks/useAccountSlideoutAdditionalMenuItems';
import React from 'react';
import { RmsGroupsPanel } from './types';

export const GroupsPage: React.FC = () => {
    const { getAccountAdditionalMenuItems } = useAccountSlideoutAdditionalMenuItems();

    return (
        <RmsGroupsPanel customMemberSlideoutMenuItems={getAccountAdditionalMenuItems} customMemberDetailsComponent={RmsAccountDetails} />
    );
};
